import React, {useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {CABINET_LABELS, SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import cabinetWorkspace from "../../../../canvas/core/cabinet/cabinetWorkspace";
import SQFTFeaturesHeader from "./commonParts/SQFTFeaturesHeader";
//import SqftOptionsItemList from "./commonParts/SqftOptionsItemList";
import SqftOptionsRelatedItemList from "./commonParts/SqftOptionsRelatedItemList";
//import SqftOptionsRelatedItems from "./part/SqftOptionsRelatedItems";
//import SqftOptionsBoxes from "./part/SqftOptionsBoxes";

const SqftNavigationUpper = (props) => {
  const {activeFeature} = props;
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper
  const [searchInputValue, setSearchInput] = useState('');

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")}>
      <div className="side-level2__inner ">
        <SQFTFeaturesHeader headerTitle={ <FormattedMessage id={"sqft.navigation.submenu.upperTitle"}/> }
                            partId={CABINET_LABELS.upper_cabinet_boxes}
                            //partId={CABINET_LABELS.top_cabinet}
                            searchInputValue={searchInputValue}
                            setSearchInput={setSearchInput}/>
        {expanded ? (
          <SqftOptionsRelatedItemList activeFeature={activeFeature}
                                      partId={CABINET_LABELS.top_cabinet}
                                      shouldSortByWidth={true}
                                      searchInputValue={searchInputValue}
                                      itemClickCallback={(feature, parentFeature) => {
                                        cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}
                                      }
          />
        ) : null}
        {/*<SqftOptionsItemList activeFeature={activeFeature}*/}
        {/*                     partId={CABINET_LABELS.upper_cabinet_boxes}*/}
        {/*                     parentPartId={CABINET_LABELS.top_cabinet}*/}
        {/*                     expanded={expanded}*/}
        {/*                     shouldSortByWidth={true}*/}
        {/*                     searchInputValue={searchInputValue}*/}
        {/*                     itemClickCallback={(feature, parentFeature) => {*/}
        {/*                       cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}*/}
        {/*                     }*/}
        {/*/>*/}

        {
          // <SqftOptionsBoxes activeFeature={activeFeature}
          //                   partId={CABINET_LABELS.upper_cabinet_boxes}
          //                   itemClickCallback={(feature, parentFeature, width, height, depth) => {
          //                     cabinetWorkspace.cabinetShapes.addShape(feature.partId, feature, parentFeature, width, height, depth)}
          //                   }
          // />
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {sqftFromFeature} = store.sqftState;
  return {
    menuOpened,
    activeFeature: sqftFromFeature ? sqftFromFeature.cartFeature : null
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationUpper);
